import { unref } from 'vue';

import { useI18n } from '@modules/i18n/composables';

import { TRANSLATION_GROUP_ROLES_AND_PERMISSIONS } from '../constants';

export interface RolesAndPermissionsComposable {
  translate(shortCode: string): string;
}

export default function useRolesAndPermissionsTranslate(): RolesAndPermissionsComposable {
  const { getTranslation } = useI18n();

  function translate(shortCode: string): string {
    return unref(getTranslation(TRANSLATION_GROUP_ROLES_AND_PERMISSIONS, shortCode));
  }

  return {
    translate,
  };
}
